// eslint-disable-next-line import/prefer-default-export
export const PARTNERS_HOME_PATH = '/partners'
